import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
    _t,
    getCookie,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL, demo } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const PaypalSetup = () => {
    const { t } = useTranslation();
    const history = useHistory();

    // use state
    const [paypalInput, setpaypalInput] = useState({
        clientId: null,
        secretKey: null,
    });

    // checkbox state
    const [isChecked, setIsChecked] = useState(false);

    // handle paypal input
    const handlePaypalInput = (e) => {
        setpaypalInput({ ...paypalInput, [e.target.name]: e.target.value });
    }

    // handle checkbox
    const handleCheckbox = (e) => {
        setIsChecked(e.target.checked);
    }

    // get paypal details
    const getpaypalDetails = () => {
        const url = BASE_URL + `/settings/get-paypal-data`;
        return axios
            .get(url, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            })
            .then((res) => {
                setpaypalInput({
                    clientId: res.data.clientId,
                    secretKey: res.data.secretKey,
                });

                if (res.data.show == 'YES') {
                    setIsChecked(true);
                } else {
                    setIsChecked(false);
                }
            }).catch((res) => {
                console.log(res);
            });
    }

    //useEffect == componentDidMount
    useEffect(() => {
        getpaypalDetails();
    }, []);

    // handle submit
    const handleSubmit = (e) => {
        e.preventDefault();

        if (demo == "YES") {
            toast.success(`${_t(t("Sorry,This is demo purpose only"))}`, {
                position: "bottom-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
        } else {

            const url = BASE_URL + `/settings/setup-paypal`;
            let formData = new FormData();
            formData.append("clientId", paypalInput.clientId);
            formData.append("secretKey", paypalInput.secretKey);
            formData.append("show", isChecked);
            return axios
                .post(url, formData, {
                    headers: { Authorization: `Bearer ${getCookie()}` },
                })
                .then((res) => {
                    toast.success(`${_t(t("paypal setup successfully"))}`, {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                    });
                }).catch((res) => {
                    console.log(res);
                });
        }
    }
    return (
        <>
            <Helmet>
                <title>{_t(t("Paypal"))}</title>
            </Helmet>


            {/* main body */}
            <main id="main" data-simplebar>
                <div className="container">
                    <div className="row t-mt-10 gx-2">
                        {/* left Sidebar */}
                        <div className="col-lg-3 col-xxl-2 t-mb-30 mb-lg-0">
                            <ManageSidebar />
                        </div>
                        {/* left Sidebar ends */}

                        {/* Rightbar contents */}
                        <div className="col-lg-9 col-xxl-10 t-mb-30 mb-lg-0">
                            <div className="t-bg-white p-3 p-md-5">
                                <div>
                                    <h4 className="text-secodary my-4">Setup PayPal</h4>
                                </div>
                                <hr />
                                <form onSubmit={handleSubmit}>
                                    <div class="mb-3">
                                        <label for="stripeclientid" class="form-label">PayPal Client Id</label>
                                        <input onChange={handlePaypalInput}
                                            type="text" class="form-control"
                                            name="clientId" id="stripeclientid"
                                            defaultValue={paypalInput.clientId}
                                            placeholder="pk_test_51H2XGOKJQvOIJEOikQ62q1vuUW" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="stripesecretkey" class="form-label">PayPal Secret Key</label>
                                        <input onChange={handlePaypalInput}
                                            type="text"
                                            class="form-control"
                                            name="secretKey"
                                            id="stripesecretkey"
                                            defaultValue={paypalInput.secretKey}
                                            placeholder="sk_test_51H2XGOKJQvOIJEOiu" />
                                    </div>
                                    <div class="mb-3">
                                        <input type="checkbox"
                                            id="stripecheckbox"
                                            defaultValue={isChecked}
                                            onChange={handleCheckbox}
                                            checked={isChecked}
                                        />
                                        <label htmlFor="stripecheckbox" className="form-label ml-4">show</label>
                                    </div>
                                    <div class="mb-3">
                                        <button className="btn btn-primary text-capitalize">setup</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* Rightbar contents end*/}
                    </div>
                </div>
            </main>
            {/* main body ends */}
        </>
    );
};

export default PaypalSetup;
